import { initializeApp, getApps, getApp } from 'firebase/app';
import {
    getFirestore,
    collection,
    doc,
    getDocs,
    getDoc,
    query,
    where,
    orderBy,
    setDoc,
    addDoc,
    updateDoc,
    onSnapshot,
    runTransaction
} from 'firebase/firestore';
import { FIREBASE_CONFIG } from './constants';

// Initialize Firebase app and Firestore
// This ensures db is available for services to import
let app;
let db;

if (!getApps().length) {
    app = initializeApp(FIREBASE_CONFIG);
    db = getFirestore(app);
} else {
    app = getApp();
    db = getFirestore(app);
}

// Export db for services to use
export { db };

// Re-export common Firestore functions for convenience
export { collection, doc, getDocs, getDoc, query, where, orderBy, setDoc, addDoc, updateDoc, onSnapshot, runTransaction };

export const initializeFirebaseApp = () => {
    // Return the already initialized app and db
    if (!app || !db) {
        if (!getApps().length) {
            app = initializeApp(FIREBASE_CONFIG);
            db = getFirestore(app);
        } else {
            app = getApp();
            db = getFirestore(app);
        }
    }
    return { app, db };
};

export default app;

